"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _formatters = require("../utils/formatters");

var Working = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Working, _Record);

  function Working(values) {
    (0, _classCallCheck2.default)(this, Working);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Working).call(this, (0, _formatters.cleanObject)(values)));
  }

  return Working;
}((0, _immutable.Record)({
  headline: '',
  imageUrl: '',
  text: ''
}));

exports.default = Working;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/Working.js
// module id = 772
// module chunks = 209 210 211 212